import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  userData({ data }) {
    return {
      'Account Id': data.account_id,
      'Requester Name': data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
    };
  },
  pageViewed({ data }) {
    return {
      ...Transforms.userData({ data }),
      Page: data.page,
    };
  },
  fieldInput({ data }) {
    return {
      ...Transforms.userData({ data }),
      'Field Name': data.field,
    };
  },
  supportAccessGranted({ data }) {
    return {
      ...Transforms.userData({ data }),
      'Was Already Granted': data.wasAlreadyGranted ?? false,
    };
  },
  docsSuggestionClicked({ data }) {
    return {
      ...Transforms.userData({ data }),
      Title: data.title,
      URL: data.url,
      Page: data.page,
    };
  },
};

export default Transforms;
